<template>
  <div>
    <vxe-grid
      border
      resizable
      auto-resize
      highlight-hover-row
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'success' : 'warning'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.orderGoodsDefaultImageUrl
              ? $osscdn(row.orderGoodsDefaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
          :preview-src-list="[
            row.orderGoodsDefaultImageUrl
              ? $osscdn(row.orderGoodsDefaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:hasShipping="{ row }">
        <el-tag
          v-if="row.v_hasShipping"
          size="mini"
          :type="row.hasShipping === 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_hasShipping }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format: (n) => format(n, 2),
      integerFormat: (n) => format(n),
    }
  },
}
</script>
